import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { httpInterceptor } from './common-resource/services/http.interceptor';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withFetch(),
      withInterceptors([httpInterceptor])
    ), 
     provideRouter(
      routes,
      withEnabledBlockingInitialNavigation() //blocks the first navigation,once routes are finalized Correct route renders first time
     ),
    provideClientHydration(
      withEventReplay()  // optional but highly recommended
    )

  ]
};
